import { useGlobalPopupStore } from 'stores/globalPopups/globalPopups';

export function GlobalPopup() {
  const { popup } = useGlobalPopupStore();
  return <div className="flex flex-col items-center justify-center w-full h-full">{popup ?? null}</div>;
}
